document.addEventListener("DOMContentLoaded", function () {
  "use strict";

  /* =========================================================
     WARRANTY RULES
  ========================================================= */

  const warrantyRulesByCategory = {
    EARBUDS: {
      apply: [
        "Both earbuds not working",
        "Charging case not charging earbuds properly (internal fault)",
        "Earbuds not charging (without port damage or external force)",
        "Abnormal battery drain (manufacturing defect only)",
        "Microphone not working (hardware defect, not blockage)",
        "Connectivity / pairing failure (Bluetooth fault, not device compatibility issue)"
      ],
      notApply: [
        "Water, sweat, or any moisture damage",
        "Physical damage (drop, crack, pressure, or broken parts)",
        "Dust, earwax, or blockage affecting sound output",
        "Charging port damage caused by force, misuse, or improper insertion",
        "Unauthorized repair, opening, or tampering",
        "Cosmetic damage (scratches, paint wear, discoloration)",
        "Charging cable not covered under warranty",
        "Burnt damage due to over-voltage, over-charging, or wrong adapter use",
        "Damage caused by third-party accessories or incompatible devices"
      ]
    },
    "SMART WATCH": {
      apply: [
        "Display not working (internal display failure)",
        "Touch not working (without physical or water damage)",
        "Sensors not working (heart rate, SpO2, etc., hardware fault)",
        "Battery charging issue (internal battery or board fault)",
        "System crash / boot failure / software malfunction (not caused by damage or misuse)"
      ],
      notApply: [
        "Screen crack, glass break, or display damage",
        "Water or moisture damage (including swimming, rain, or liquid exposure)",
        "Physical damage (drop, dent, pressure, or impact damage)",
        "Strap damage (torn, broken, or wear & tear)",
        "Charging pin damage due to force or misuse",
        "Burnt or short-circuit damage due to wrong charger or voltage fluctuation",
        "Unauthorized repair, opening, or tampering",
        "Charging cable not covered under warranty",
        "Cosmetic damage (scratches, paint fade, normal wear & tear)",
        "Missing proof of purchase"
      ]
    },
    SPEAKER: {
      apply: [
        "No sound output (internal speaker failure)",
        "Sound distortion during normal usage (not due to high volume misuse)",
        "Bluetooth connectivity failure (pairing or module fault)",
        "Battery not holding charge (manufacturing defect)",
        "Charging issue (internal circuit fault only)"
      ],
      notApply: [
        "Blown speaker due to high volume or misuse",
        "Physical damage (drop, crack, pressure, or broken body)",
        "Punctured or damaged speaker grill",
        "Water or moisture damage (including rain or liquid exposure)",
        "Solar panel / solar plate damage (not covered under warranty)",
        "Charging pin damage due to force or improper use",
        "TF card slot damage due to misuse",
        "Button damage due to force or pressing hard",
        "Remote control / Charging cable / Built-in accessories not covered",
        "Deep dents, crushed casing, or structural damage",
        "Short-circuit damage due to moisture or voltage fluctuation",
        "Use of higher voltage charger (than 5V/2A) will void warranty"
      ]
    },
    HEADPHONE: {
      apply: [
        "One side not working (left or right), without physical damage",
        "Both sides not working",
        "Charging issue (internal fault only)",
        "Abnormal battery drain (manufacturing defect only)",
        "Microphone not working (hardware failure)",
        "Connectivity / pairing failure (Bluetooth malfunction)"
      ],
      notApply: [
        "Physical damage (drop, crack, pressure, or crushed earcup)",
        "Broken wire due to pulling, twisting, or misuse",
        "Dust or earwax blocking speaker output",
        "Charging port damage due to force or improper use",
        "Unauthorized repair, opening, or tampering",
        "Cosmetic damage (scratches, color fade, wear & tear)",
        "Charging cable / accessories not covered under warranty"
      ]
    },
    "POWER BANK": {
      apply: [
        "Not charging (internal circuit fault)",
        "Output ports not working (USB / Type-C / other ports)",
        "Battery not storing or holding charge (manufacturing defect)",
        "Display / LED indicator failure"
      ],
      notApply: [
        "Swelling or battery bloating",
        "Burnt damage or voltage damage (over-voltage / wrong adapter use)",
        "Water or moisture damage (including short-circuit due to moisture)",
        "Physical damage (drop, crack, or heavy impact)",
        "Broken or damaged ports due to force or misuse",
        "Deep dents, crushed casing, or structural damage",
        "Unauthorized repair, opening, or tampering",
        "Attached / built-in cables (input or output) not covered under warranty"
      ]
    },
    CHARGER: {
      apply: [
        "Not charging (internal circuit fault)",
        "Output port not working (USB / Type-C / socket failure)",
        "Abnormal overheating (beyond normal operating temperature, internal fault only)"
      ],
      notApply: [
        "Burnt, melted, or short-circuited charger",
        "Voltage fluctuation / power surge damage",
        "Physical damage (cracks, breakage, or crushed body)",
        "Bent, broken, or damaged pins",
        "Water or moisture damage (including internal short circuit)",
        "Unauthorized repair, opening, or tampering",
        "Charging cable not covered under warranty",
        "Cosmetic damage (scratches, minor marks, wear & tear)"
      ]
    },
    NECKBAND: {
      apply: [
        "One side not working (left or right), without physical damage",
        "Both sides not working",
        "Charging issue (internal fault only)",
        "Abnormal battery drain (manufacturing defect only)",
        "Microphone not working (hardware failure)",
        "Connectivity / pairing failure (Bluetooth issue)"
      ],
      notApply: [
        "Water, sweat, or moisture damage",
        "Physical damage (drop, crack, pressure, or broken housing)",
        "Broken wire due to pulling, twisting, or misuse",
        "Dust or earwax blocking speaker output",
        "Charging port damage due to force or improper insertion",
        "AUX port or Memory card slot damage due to misuse",
        "Unauthorized repair, opening, or tampering",
        "Cosmetic damage (scratches, paint fade, normal wear & tear)",
        "Charging cable and AUX cable not covered under warranty"
      ]
    },
    "HOME THEATRE": {
      apply: [
        "No sound output (internal fault only)",
        "Amplifier failure",
        "Internal motherboard failure",
        "Bluetooth connectivity failure",
        "Channel failure (Left / Right / Surround speaker issue)"
      ],
      notApply: [
        "Installation or setup issues (incorrect wiring)",
        "Speaker damage due to misuse (tear, burnt coil, overloading)",
        "Physical damage (drop, crack, pressure, or broken unit)",
        "Water or moisture damage (including short circuit due to liquid)",
        "Voltage fluctuation or power surge damage",
        "Punctured or damaged speaker grill",
        "HDMI / power / external ports damaged due to force or misuse",
        "External wiring faults or cut cables",
        "Remote control and accessory cables not covered",
        "Button damage due to force",
        "Deep dents or crushed casing",
        "Missing proof of purchase"
      ]
    },
    MIC: {
      apply: [
        "Both microphones not working (manufacturing defect)",
        "Charging case not charging mic properly (internal fault)",
        "Mic not charging (no physical damage or port misuse)",
        "Abnormal battery drain (verified manufacturing defect only)",
        "Microphone not working (hardware failure, not due to blockage or damage)",
        "Connectivity / pairing failure (internal Bluetooth or wireless system fault)"
      ],
      notApply: [
        "Water, sweat, or moisture damage of any type",
        "Physical damage (drop, crack, pressure, broken parts)",
        "Mouth PC, dust, or blockage affecting sound quality",
        "Charging port damage due to force, misuse, or wrong insertion",
        "Unauthorized repair, opening, or tampering",
        "Cosmetic damage (scratches, paint wear, discoloration)",
        "Charging cable or external accessories not covered",
        "Burnt damage due to wrong adapter, over-voltage, or power surge",
        "Missing proof of purchase"
      ]
    },
    "CAR CHARGERNO": {
      apply: ["Manufacturing defects", "Power output failure"],
      notApply: ["Physical damage", "Burnt due to vehicle voltage surge", "Loose contact due to force"]
    },
    "CLIP CHARGERNO": {
      apply: ["Manufacturing defects"],
      notApply: ["Spring break due to force", "Burnt connectors", "Physical damage"]
    },
    BATTERYNO: {
      apply: ["Manufacturing defects", "Not holding charge"],
      notApply: ["Swelling due to overcharging", "Terminal damage", "Water damage"]
    }
  };


  /* =========================================================
     ELEMENTS
  ========================================================= */

  const inputEl = document.getElementById("serial-input-main");
  const searchBtn = document.getElementById("search-btn-main");
  const resultEl = document.getElementById("warranty-result-main");

  const categoryWarranty = document.getElementById("category-warranty");
  const warrantyApply = document.getElementById("warranty-apply");
  const warrantyNotApply = document.getElementById("warranty-not-apply");

  const faqItems = document.querySelectorAll(".faq-item");
  const categoryItems = document.querySelectorAll(".category-item");


  /* =========================================================
     INITIAL STATE
  ========================================================= */

  if (resultEl) {
    resultEl.style.display = "none";
    resultEl.innerHTML = "";
  }

  if (categoryWarranty) {
    categoryWarranty.style.display = "none";
  }


  /* =========================================================
     DATE FORMAT (100% STABLE FOR SAFARI & CHROME)
  ========================================================= */

  function formatDisplayDate(dateStr) {
    if (!dateStr || dateStr === "NO DATE") {
      return "-";
    }

    const parts = String(dateStr).split("T")[0].split("-");
    
    if (parts.length === 3) {
      const year = parts[0];
      const monthNum = parseInt(parts[1], 10) - 1;
      const day = parts[2];

      const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      if (monthNum >= 0 && monthNum < 12) {
        return day + " " + months[monthNum] + " " + year;
      }
    }

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      return dateStr;
    }

    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return day + " " + month + " " + year;
  }


  /* =========================================================
     ESCAPE HTML
  ========================================================= */

  function escapeHTML(value) {
    if (value === null || value === undefined) {
      return "";
    }

    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  /* =========================================================
     CATEGORY DETECTION
  ========================================================= */

  function detectCategory(serialNumber, apiCategory) {
    const sn = String(serialNumber || "").toUpperCase();
    const apiCat = String(apiCategory || "").toUpperCase();

    if (sn.includes("WATCH") || apiCat.includes("WATCH")) {
      return "SMART WATCH";
    }
    if (sn.includes("EARBUD") || apiCat.includes("EARBUD")) {
      return "EARBUDS";
    }
    if (sn.includes("SPEAKER") || apiCat.includes("SPEAKER")) {
      return "SPEAKER";
    }
    if (sn.includes("HEADPHONE") || apiCat.includes("HEADPHONE")) {
      return "HEADPHONE";
    }
    if (sn.includes("POWERBANK") || sn.includes("POWER BANK") || sn.includes("POWER") || apiCat.includes("POWER")) {
      return "POWER BANK";
    }
    if (sn.includes("CHARGER") || apiCat.includes("CHARGER")) {
      return "CHARGER";
    }
    if (sn.includes("NECKBAND") || apiCat.includes("NECKBAND")) {
      return "NECKBAND";
    }
    if (sn.includes("MICROPHONE") || sn.includes("MIC") || apiCat.includes("MICROPHONE") || apiCat.includes("MIC")) {
      return "MIC";
    }

    return null;
  }


  /* =========================================================
     SHOW CATEGORY WARRANTY
  ========================================================= */

  function showCategoryWarranty(category) {
    if (!categoryWarranty) {
      return;
    }

    let ruleKey = String(category || "").toUpperCase().trim();
    const rules = warrantyRulesByCategory[ruleKey] || warrantyRulesByCategory["EARBUDS"];

    if (warrantyApply) {
      warrantyApply.innerHTML = rules.apply
        .map(function (item) {
          return `
            <p>
              <span></span>
              ${escapeHTML(item)}
            </p>
          `;
        })
        .join("");
    }

    if (warrantyNotApply) {
      warrantyNotApply.innerHTML = rules.notApply
        .map(function (item) {
          return `
            <p>
              <span></span>
              ${escapeHTML(item)}
            </p>
          `;
        })
        .join("");
    }

    categoryWarranty.style.display = "block";
  }


  /* =========================================================
     HIDE CATEGORY WARRANTY
  ========================================================= */

  function hideCategoryWarranty() {
    if (categoryWarranty) {
      categoryWarranty.style.display = "none";
    }
  }


  /* =========================================================
     SEARCH WARRANTY
  ========================================================= */

  async function searchWarranty() {
    if (!inputEl) {
      console.error("Warranty input not found.");
      return;
    }

    const serialNumber = inputEl.value.trim().toUpperCase();

    if (!serialNumber) {
      inputEl.focus();
      showMessage("Please enter your serial number.", "warning");
      return;
    }

    if (searchBtn) {
      searchBtn.disabled = true;
      searchBtn.classList.add("is-loading");
      searchBtn.innerHTML = "Checking...";
    }

    if (resultEl) {
      resultEl.style.display = "block";
      resultEl.innerHTML = `
        <div class="warranty-loading">
          <div class="warranty-loading-spinner"></div>
          <p>Checking warranty...</p>
        </div>
      `;
    }

    hideCategoryWarranty();

    try {
      const apiURL = "https://data.login.com.pk/api.php?sn=" + encodeURIComponent(serialNumber);

      const response = await fetch(apiURL, {
        method: "GET",
        cache: "no-store"
      });

      if (!response.ok) {
        throw new Error("Server returned " + response.status);
      }

      const data = await response.json();
      console.log("Warranty API Response:", data);

      if (data && data.success === true && data.data) {
        renderWarrantyResult(data.data);
      } else {
        showNotFound(
          serialNumber,
          data && data.message ? data.message : "No warranty record found for this serial number."
        );
      }

    } catch (error) {
      console.error("Warranty API Error:", error);
      showMessage("Unable to connect to warranty server. Please try again.", "error");
    } finally {
      if (searchBtn) {
        searchBtn.disabled = false;
        searchBtn.classList.remove("is-loading");
        searchBtn.innerHTML = "Check Your Warranty";
      }
    }
  }


  /* =========================================================
     SIMPLE MESSAGE
  ========================================================= */

  function showMessage(message, type) {
    if (!resultEl) {
      return;
    }

    resultEl.style.display = "block";
    resultEl.innerHTML = `
      <div class="warranty-message warranty-message--${type}">
        <div class="warranty-message-icon">
          ${type === "error" ? "!" : type === "warning" ? "!" : "✓"}
        </div>
        <div>
          <strong>
            ${type === "error" ? "Connection Error" : type === "warning" ? "Serial Number Required" : "Warranty"}
          </strong>
          <p>${escapeHTML(message)}</p>
        </div>
      </div>
    `;
  }


  /* =========================================================
     NOT FOUND
  ========================================================= */

  function showNotFound(serialNumber, message) {
    if (!resultEl) {
      return;
    }

    resultEl.style.display = "block";
    resultEl.innerHTML = `
      <div class="warranty-message warranty-message--error">
        <div class="warranty-message-icon">!</div>
        <div>
          <strong>Warranty Not Found</strong>
          <p>Serial Number: <b>${escapeHTML(serialNumber)}</b></p>
          <p>${escapeHTML(message)}</p>
        </div>
      </div>
    `;

    hideCategoryWarranty();
  }


  /* =========================================================
     RENDER WARRANTY RESULT (UPDATED STATUS CHECK)
  ========================================================= */

  function renderWarrantyResult(w) {
    const serialNumber = w.serial_number || w.serialNumber || inputEl.value.trim();
    const customerCode = w.customer_code || "-";
    const modelNumber = w.model_no || w.model || "-";
    const category = w.category_name || "-";
    const apiStatus = String(w.status || w.warranty_status || "").trim();

    const categoryKey = detectCategory(serialNumber, category);

    // --- AUTOMATIC STATUS CHECK ---
    let statusText = "WARRANTY EXPIRED";
    let statusColor = "#ff3333";
    let statusBg = "rgba(255, 51, 51, 0.15)";
    let statusBorder = "rgba(255, 51, 51, 0.4)";
    let svgCheckPath = '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>';

    const isNotEligibleText = String(w.warranty_start).toUpperCase().includes("NOT") || 
                              String(w.warranty_expiry).toUpperCase().includes("NOT") || 
                              apiStatus.toLowerCase().includes("not eligible");

    if (isNotEligibleText) {
      statusText = "WARRANTY NOT COVERED";
      statusColor = "#ffa500"; // Orange color
      statusBg = "rgba(255, 165, 0, 0.15)";
      statusBorder = "rgba(255, 165, 0, 0.4)";
      svgCheckPath = '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>';
    } else {
      let isWarrantyValid = false;
      const expiryDateStr = w.warranty_expiry;

      if (expiryDateStr && expiryDateStr !== "NO DATE") {
        const expiryDate = new Date(expiryDateStr);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        if (!isNaN(expiryDate.getTime()) && expiryDate >= currentDate) {
          isWarrantyValid = true;
        }
      }

      if (isWarrantyValid) {
        statusText = "WARRANTY VERIFIED";
        statusColor = "#00e676";
        statusBg = "rgba(0, 230, 118, 0.15)";
        statusBorder = "rgba(0, 230, 118, 0.4)";
        svgCheckPath = '<polyline points="20 6 9 17 4 12"></polyline>';
      }
    }


    if (resultEl) {
      resultEl.style.display = "block";

      resultEl.innerHTML = `
        <style>
          .custom-warranty-card {
            background: url('https://cdn.shopify.com/s/files/1/0758/7800/7080/files/warranty_card_back.webp?v=1786521543') center/cover no-repeat !important;
            border-radius: 12px;
            padding: 25px;
            color: #fff;
            width: 100%;
            max-width: 750px;
            margin: 0 auto;
            box-shadow: 0 10px 30px rgba(0,0,0,0.5);
            font-family: inherit;
            box-sizing: border-box;
          }
          .custom-warranty-card .card-top-title {
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 1px;
            color: #ffffff;
          }
          .custom-warranty-card .date-value {
            font-size: 29px;
            font-weight: 700;
            color: #fff100;
          }
          .custom-warranty-card .date-label {
            font-size: 19px;
            color: #fff;
            margin-bottom: 2px;
            font-weight: 500;
          }
          .custom-warranty-card .bottom-row {
            display: flex;
            justify-content: space-between;
            gap: 68px;
            padding-top: 5px;
          }

          /* Mobile Responsive Query */
          @media screen and (max-width: 768px) {
            .custom-warranty-card {
              padding: 15px !important;
            }
            .custom-warranty-card .card-top-container {
              flex-direction: column !important;
              align-items: center !important;
              gap: 10px !important;
            }
            .custom-warranty-card .card-top-title {
              font-size: 15px !important;
            }
            .custom-warranty-card .status-container .verified {
              font-size: 9px !important;
            }
            .custom-warranty-card .status-container .cuscode {
              font-size: 11px !important;
            }
            .custom-warranty-card .status-container {
              gap: 10px !important;
              padding: 10px 0 0 0 !important;
              display: flex !important;
              justify-content: space-between !important;
              align-items: center !important;
            }
            .custom-warranty-card .dates-container {
              gap: 37px !important;
              padding: 10px 0 !important;
              display: flex !important;
              justify-content: space-between !important;
              align-items: center !important;
            }
            .custom-warranty-card .dates-divider {
              display: none !important;
            }
            .custom-warranty-card .date-label {
              font-size: 12px !important;
            }
            .custom-warranty-card .date-value {
              font-size: 13px !important;
            }
            .custom-warranty-card .bottom-row {
              gap: 12px !important;
              display: flex !important;
              justify-content: space-between !important;
            }
            .custom-warranty-card .bottom-col {
              text-align: left !important;
            }

            .custom-warranty-card .bottom-row .bottom-row-text{
              font-size: 8px !important;
            }

            .custom-warranty-card .bottom-row .bottom-row-text-m{
              font-size: 9px !important;
            }
            .logo-img-b img {
              height: 43px !important;
            }
          }

          .warranty-btn-main {
            display: inline-flex;
            align-items: stretch;
            background: #e31b23;
            color: #ffffff;
            border: none;
            border-radius: 8px;
            font-family: inherit;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
            transition: background 0.2s ease, transform 0.1s ease;
            padding: 0;
          }

          .warranty-btn-main:hover {
            background: #000000ff;
          }

          .warranty-btn-main:active {
            transform: scale(0.98);
          }

          .warranty-btn-main .btn-text {
            padding: 12px 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .warranty-btn-main .btn-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 18px;
            background: rgba(0, 0, 0, 0.15);
            border-left: 1px solid rgba(255, 255, 255, 0.15);
          }

          .hrdivider hr.solid {
            border-top: 1px solid #fff;
            margin: 10px;
          }
        </style>

        <div id="warrantyCardElement" class="warranty-card-output custom-warranty-card">

          <!-- Top Row -->
          <div class="card-top-container" style="display: flex;justify-content: center;align-items: center;gap: 20px;flex-direction: column;">
            <div class="logo-img-b" style="display: flex; align-items: center;">
              <img
                src="https://cdn.shopify.com/s/files/1/0758/7800/7080/files/all_in_the_vibe_logo_1_-01.png?v=1786534423"
                alt="LOGIN Logo"
                style="height: 67px; width: 100%;"
              >
            </div>
          </div>

          <!-- Status Row -->
          <div class="status-container" style="margin-bottom: 20px;padding: 10px 0 0 0;display: flex;justify-content: space-between;align-items: center;">
            <div class="verified" style="display: inline-flex; align-items: center; background: ${statusBg}; border: 1px solid ${statusBorder}; padding: 5px 12px; border-radius: 20px; color: ${statusColor}; font-size: 12px; font-weight: 700; letter-spacing: 0.5px;">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="${statusColor}" stroke-width="3" style="margin-right: 6px;">
                ${svgCheckPath}
              </svg>
              ${statusText}
            </div>
            <div class="card-top-title">
              WARRANTY CARD
            </div>
          </div>

          <!-- Middle Row (Dates) -->
          <div class="dates-container" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0; margin-bottom: 20px;">
            <div style="flex: 1; text-align: left;">
              <div class="date-label">Warranty Effective From</div>
              <div class="date-value">${formatDisplayDate(w.warranty_start)}</div>
            </div>

            <div class="dates-divider" style="width: 1px;height: 75px;background: rgb(255 255 255);margin: 0 15px;display: block;"></div>

            <div style="flex: 1; text-align: right;" class="bottom-col">
              <div class="date-label">Warranty Valid Until</div>
              <div class="date-value">${formatDisplayDate(w.warranty_expiry)}</div>
            </div>
          </div>

          <div class="hrdivider">
            <hr class="solid">
          </div>

          <!-- Bottom Row (Details) -->
          <div class="bottom-row">
            <div style="flex: 1;" class="bottom-col">
              <div class="bottom-row-text" style="font-size: 13px; color: #fff; margin-bottom: 4px; text-transform: uppercase;">Model No</div>
              <div class="bottom-row-text-m" style="font-size: 12px; font-weight: 700; color: #fff100;">${escapeHTML(modelNumber)}</div>
            </div>

            <div style="flex: 1;" class="bottom-col">
              <div class="bottom-row-text" style="font-size: 13px; color: #fff; margin-bottom: 4px; text-transform: uppercase;">Category</div>
              <div class="bottom-row-text-m" style="font-size: 12px; font-weight: 700; color: #fff100;">${escapeHTML(category)}</div>
            </div>

            <div style="flex: 1;" class="bottom-col">
              <div class="bottom-row-text" style="font-size: 13px; color: #fff; margin-bottom: 4px; text-transform: uppercase;">Customer Code</div>
              <div class="bottom-row-text-m" style="font-size: 12px; font-weight: 700; color: #fff100;">${escapeHTML(customerCode)}</div>
            </div>

            <div style="flex: 1; text-align: right;" class="bottom-col">
              <div class="bottom-row-text" style="font-size: 13px; color: #fff; margin-bottom: 4px; text-transform: uppercase;">Serial Number</div>
              <div class="bottom-row-text-m" style="font-size: 12px; font-weight: 700; color: #fff100; word-break: break-all;">${escapeHTML(serialNumber)}</div>
            </div>
          </div>

        </div>

        <div class="warranty-download-wrapper" style="text-align: center; margin-top: 29px;">
          <button id="download-card-btn" class="warranty-btn-main" type="button">
            <span class="btn-text">Download Warranty Card</span>
            <span class="btn-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </span>
          </button>
        </div>
      `;

      const downloadButton = document.getElementById("download-card-btn");
      if (downloadButton) {
        downloadButton.addEventListener("click", downloadWarrantyCard);
      }
    }

    if (categoryKey) {
      showCategoryWarranty(categoryKey);
    }

    setTimeout(function () {
      if (resultEl) {
        resultEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 150);
  }


  /* =========================================================
     DOWNLOAD WARRANTY CARD
  ========================================================= */

  async function downloadWarrantyCard() {
    const card = document.getElementById("warrantyCardElement");
    if (!card) {
      return;
    }

    if (typeof html2canvas === "undefined") {
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js");
    }

    try {
      const canvas = await html2canvas(card, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#111111"
      });

      const link = document.createElement("a");
      const serial = inputEl ? inputEl.value.trim() || "LOGIN" : "LOGIN";

      link.download = "Warranty-Card-" + serial + ".png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (error) {
      console.error("Warranty card download error:", error);
      alert("Unable to download warranty card. Please try again.");
    }
  }


  /* =========================================================
     LOAD EXTERNAL SCRIPT
  ========================================================= */

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const script = document.createElement("script");
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }


  /* =========================================================
     SEARCH EVENTS
  ========================================================= */

  if (searchBtn) {
    searchBtn.addEventListener("click", function (event) {
      event.preventDefault();
      searchWarranty();
    });
  }

  if (inputEl) {
    inputEl.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        searchWarranty();
      }
    });
  }


  /* =========================================================
     CATEGORY CLICK
  ========================================================= */

  categoryItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const text = (this.querySelector("p") ? this.querySelector("p").textContent : "").toUpperCase();

      let category = "EARBUDS";

      if (text.includes("WATCH")) {
        category = "SMART WATCH";
      } else if (text.includes("EARBUD")) {
        category = "EARBUDS";
      } else if (text.includes("SPEAKER")) {
        category = "SPEAKER";
      } else if (text.includes("HEADPHONE")) {
        category = "HEADPHONE";
      } else if (text.includes("POWER")) {
        category = "POWER BANK";
      } else if (text.includes("CABLE")) {
        category = "DATA CABLES";
      }

      showCategoryWarranty(category);

      if (categoryWarranty) {
        setTimeout(function () {
          categoryWarranty.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 100);
      }
    });
  });


  /* =========================================================
     FAQ ACCORDION
  ========================================================= */

  faqItems.forEach(function (item) {
    const question = item.querySelector(".faq-question");

    if (!question) {
      return;
    }

    question.addEventListener("click", function (event) {
      event.preventDefault();

      const isActive = item.classList.contains("active");

      faqItems.forEach(function (otherItem) {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
          const otherIcon = otherItem.querySelector(".plus-icon");
          if (otherIcon) {
            otherIcon.textContent = "+";
          }
        }
      });

      if (isActive) {
        item.classList.remove("active");
      } else {
        item.classList.add("active");
      }

      const icon = item.querySelector(".plus-icon");
      if (icon) {
        icon.textContent = item.classList.contains("active") ? "−" : "+";
      }
    });
  });


  /* =========================================================
     FAQ BUTTON DIRECT SUPPORT
  ========================================================= */

  document.querySelectorAll(".faq-toggle").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.stopPropagation();
    });
  });


  /* =========================================================
     SIMPLE CATEGORY SLIDER
  ========================================================= */

  const categorySlider = document.querySelector(".category-slider");

  if (categorySlider) {
    categorySlider.addEventListener(
      "wheel",
      function (event) {
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
          event.preventDefault();
          categorySlider.scrollLeft += event.deltaY;
        }
      },
      { passive: false }
    );
  }


  /* =========================================================
     QR SCANNER
  ========================================================= */

  const scanButton = document.getElementById("mobile-scan-btn");
  const scannerWrapper = document.getElementById("reader-wrapper");
  const closeScanner = document.getElementById("close-scanner");

  let qrScanner = null;

  if (scanButton) {
    scanButton.addEventListener("click", async function () {
      if (!scannerWrapper) {
        return;
      }

      scannerWrapper.style.display = "block";

      try {
        if (typeof Html5Qrcode === "undefined") {
          await loadScript("https://unpkg.com/html5-qrcode");
        }

        if (typeof Html5Qrcode === "undefined") {
          throw new Error("QR scanner library failed to load.");
        }

        const reader = document.getElementById("reader");
        if (!reader) {
          return;
        }

        reader.innerHTML = "";
        qrScanner = new Html5Qrcode("reader");

        await qrScanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 220, height: 220 } },
          function (decodedText) {
            inputEl.value = decodedText.trim();
            stopQRScanner();
            searchWarranty();
          },
          function () {
            /* Ignore scanning errors */
          }
        );

      } catch (error) {
        console.error("QR scanner error:", error);
        scannerWrapper.style.display = "none";
        alert("Unable to access camera. Please allow camera permission and try again.");
      }
    });
  }


  /* =========================================================
     CLOSE QR SCANNER
  ========================================================= */

  function stopQRScanner() {
    if (qrScanner) {
      qrScanner.stop()
        .then(function () {
          qrScanner.clear();
          qrScanner = null;
        })
        .catch(function () {
          qrScanner = null;
        });
    }

    if (scannerWrapper) {
      scannerWrapper.style.display = "none";
    }
  }

  if (closeScanner) {
    closeScanner.addEventListener("click", function () {
      stopQRScanner();
    });
  }


  /* =========================================================
     ESC KEY
  ========================================================= */

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      stopQRScanner();
    }
  });


  console.log("LOGIN Warranty Page JS initialized successfully.");
});







/* =========================================================
   E-MANUAL LIVE SEARCH & PDF DISPLAY SYSTEM
========================================================= */

document.addEventListener("DOMContentLoaded", function () {
  const manualInput = document.getElementById("manual-model-input");
  const manualSearchBtn = document.getElementById("manual-search-btn");
  const suggestionsList = document.getElementById("manual-suggestions-list");
  const manualResultsContainer = document.getElementById("manual-search-results");
  const manualCatItems = document.querySelectorAll(".manual-cat-item");

  let selectedCategory = ""; // Active category filter track karne ke liye

  function escapeHTML(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // 1. Show Suggestions Dropdown List as user types
  function handleLiveSearch(query) {
    if (!suggestionsList) return;

    const searchTerm = String(query || "").toLowerCase().trim();
    suggestionsList.innerHTML = "";

    if (searchTerm.length < 1) {
      suggestionsList.style.display = "none";
      return;
    }

    const database = window.manualProductsDatabase || [];

    // Filter by SKU, Title & Active Category (if selected)
    const matchedProducts = database.filter(item => {
      const titleMatch = item.title && item.title.toLowerCase().includes(searchTerm);
      const skuMatch = item.sku && item.sku.toLowerCase().includes(searchTerm);
      const matchesSearch = titleMatch || skuMatch;

      if (selectedCategory) {
        const itemCategory = (item.title || "").toLowerCase();
        const catMatch = itemCategory.includes(selectedCategory.toLowerCase());
        return matchesSearch && catMatch;
      }

      return matchesSearch;
    });

    if (matchedProducts.length === 0) {
      suggestionsList.style.display = "block";
      suggestionsList.innerHTML = `<li class="no-suggestion">No matching product found</li>`;
      return;
    }

    matchedProducts.forEach(product => {
      const li = document.createElement("li");
      li.className = "suggestion-item";
      
      const img = product.image || "https://cdn.shopify.com/s/files/1/0758/7800/7080/files/placeholder-image.png";
      const skuText = product.sku ? ` (${product.sku})` : "";

      li.innerHTML = `
        <img src="${escapeHTML(img)}" alt="${escapeHTML(product.title)}" />
        <span class="suggestion-title">${escapeHTML(product.title)}${escapeHTML(skuText)}</span>
      `;

      // On clicking a product from list -> render its PDF card below
      li.addEventListener("click", function () {
        manualInput.value = product.title;
        suggestionsList.style.display = "none";
        renderPDFCard(product);
      });

      suggestionsList.appendChild(li);
    });

    suggestionsList.style.display = "block";
  }

  // 2. Render Single Product PDF Card
  function renderPDFCard(item) {
    if (!manualResultsContainer) return;

    manualResultsContainer.innerHTML = "";
    manualResultsContainer.style.display = "block";

    const imageUrl = item.image || "https://cdn.shopify.com/s/files/1/0758/7800/7080/files/placeholder-image.png";
    const pdfSize = item.pdf_size ? (typeof item.pdf_size === 'number' ? (item.pdf_size / 1024).toFixed(1) + ' KB' : item.pdf_size) : 'PDF File';

    const card = document.createElement("div");
    card.className = "manual-result-card";

    // <span class="pdf-icon-badge">
    //         <svg width="24" height="28" viewBox="0 0 24 28" fill="none">
    //           <rect width="24" height="28" rx="3" fill="#E31B23"/>
    //           <text x="3" y="18" fill="white" font-size="8" font-weight="bold">PDF</text>
    //         </svg>
    //       </span>
    card.innerHTML = `
      <div class="manual-card-img">
        <img src="${escapeHTML(imageUrl)}" alt="${escapeHTML(item.title)}">
      </div>
      <div class="manual-card-details">
        <h3 class="manual-card-title">${escapeHTML(item.title).toUpperCase()} MANUAL</h3>
        <div class="manual-card-meta">
          
          <span class="pdf-size-text">${escapeHTML(pdfSize)}</span>
          <div class="manual-card-actions">
            <a href="${escapeHTML(item.pdf_url)}" target="_blank" download class="manual-btn manual-btn-download">Download PDF</a>
            <a href="${escapeHTML(item.pdf_url)}" target="_blank" class="manual-btn manual-btn-preview">Preview PDF</a>
          </div>
        </div>
      </div>
    `;

    manualResultsContainer.appendChild(card);
  }

  // Input Events
  if (manualInput) {
    manualInput.addEventListener("input", function () {
      handleLiveSearch(this.value);
    });

    // Close list when clicking outside
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".e-manual-search-wrapper")) {
        if (suggestionsList) suggestionsList.style.display = "none";
      }
    });
  }

  /* =========================================================
     UPDATED CATEGORY ICON CLICK HANDLER
  ========================================================= */
  manualCatItems.forEach(item => {
    item.addEventListener("click", function () {
      // 1. Agar same category per dubara click ho to toggle off kar de
      const isAlreadyActive = this.classList.contains("active");

      manualCatItems.forEach(cat => cat.classList.remove("active"));

      if (isAlreadyActive) {
        selectedCategory = "";
      } else {
        // 2. Clicked item par active class add karein
        this.classList.add("active");
        selectedCategory = this.getAttribute("data-category") || "";
      }

      // 3. Search input box ko clear karein aur cursor input field par layen
      if (manualInput) {
        manualInput.value = "";
        manualInput.focus();
      }

      // 4. Dropdown list & result container hide kar dein jab tak user type na kare
      if (suggestionsList) suggestionsList.style.display = "none";
      if (manualResultsContainer) manualResultsContainer.style.display = "none";
    });
  });
});




document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.warranty-tabs-nav .tab-btn');
  const tabContents = document.querySelectorAll('.tab-content-mobile');

  tabButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const targetTab = this.getAttribute('data-tab');

      // Remove active class from all buttons and contents
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      // Activate clicked button and target section
      this.classList.add('active');
      const activeContent = document.getElementById(targetTab);
      if (activeContent) {
        activeContent.classList.add('active');
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // =========================================================
  // 1. CATEGORY SLIDER LOGIC
  // =========================================================
  const sliderTrack = document.querySelector('.e-manual-categories-slider');
  const prevBtn = document.querySelector('.manual-arrow-left');
  const nextBtn = document.querySelector('.manual-arrow-right');

  if (sliderTrack && prevBtn && nextBtn) {
    const getScrollDistance = () => {
      const firstItem = sliderTrack.querySelector('.manual-cat-item');
      if (!firstItem) return 150;
      const gap = parseInt(window.getComputedStyle(sliderTrack).gap) || 10;
      return firstItem.offsetWidth + gap;
    };

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      sliderTrack.scrollBy({
        left: getScrollDistance(),
        behavior: 'smooth'
      });
    });

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      sliderTrack.scrollBy({
        left: -getScrollDistance(),
        behavior: 'smooth'
      });
    });
  }

  // =========================================================
  // 2. DROPDOWN SELECTION & CLOSE ON CLICK LOGIC
  // =========================================================
  const searchInput = document.querySelector('.manual-input-wrap input');
  const dropdown = document.querySelector('.manual-suggestions-dropdown');

  if (dropdown) {
    dropdown.addEventListener('click', function (e) {
      const item = e.target.closest('.suggestion-item');
      if (!item) return;

      // Title text extract karke input field me set karein
      const titleEl = item.querySelector('.suggestion-title');
      if (titleEl && searchInput) {
        searchInput.value = titleEl.textContent.trim();
      }

      // Dropdown ko hide aur empty karein
      dropdown.style.display = 'none';
      dropdown.innerHTML = '';
    });
  }

  // Outside click par dropdown auto-close karne ke liye
  document.addEventListener('click', function (e) {
    const searchWrapper = document.querySelector('.e-manual-search-wrapper');
    if (dropdown && searchWrapper && !searchWrapper.contains(e.target)) {
      dropdown.style.display = 'none';
      dropdown.innerHTML = '';
    }
  });
});